'use client';

import { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

function extractDomain(input) {
  try {
    const url = input.startsWith('http') ? input : `https://${input}`;
    return new URL(url).hostname;
  } catch {
    return null;
  }
}

export default function FaviconPreview({ url }) {
  const [domain, setDomain] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    setLoaded(false);
    clearTimeout(timerRef.current);

    if (!url || url.length < 4) {
      setDomain(null);
      return;
    }

    timerRef.current = setTimeout(() => {
      const d = extractDomain(url);
      setDomain(d);
    }, 500);

    return () => clearTimeout(timerRef.current);
  }, [url]);

  if (!domain) return null;

  return (
    <AnimatePresence>
      <motion.div
        key={domain}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: loaded ? 1 : 0.3, scale: 1 }}
        exit={{ opacity: 0, scale: 0.8 }}
        className="flex items-center gap-2"
      >
        <img
          src={`https://www.google.com/s2/favicons?domain=${domain}&sz=32`}
          alt=""
          width={24}
          height={24}
          className="rounded"
          onLoad={() => setLoaded(true)}
          onError={() => setLoaded(false)}
        />
        {loaded && (
          <motion.span
            initial={{ opacity: 0, x: -4 }}
            animate={{ opacity: 1, x: 0 }}
            className="text-sm font-medium text-muted-foreground"
          >
            {domain}
          </motion.span>
        )}
      </motion.div>
    </AnimatePresence>
  );
}
